module.exports = __webpack_public_path__ + "static/carry_badges-180fbe336a7ec1404c1a77c046a2fd48.svg";